import React from 'react';
import { Collapse } from '@mui/material';

import {
  Paper,
  Typography,
  Switches,
  TextField,
  CardContent,
  CardHeader,
} from '@occc-app/design-system';

import copies from './copies';

type TriggerOnProgressProps = {
  open: boolean;
};

export const TriggerOnProgress: React.FC<TriggerOnProgressProps> = ({ open }) => {
  const { title, description } = copies;

  return (
    <Paper>
      <CardHeader
        title={
          <Typography variant='h6' component='p' gutterBottom>
            {title}
          </Typography>
        }
        subheader={<Typography color='textSecondary'>{description}</Typography>}
        action={<Switches name='triggerPreferences.triggerOnProgress' data={{}} />}
      />
      <Collapse in={open} timeout='auto' unmountOnExit>
        <CardContent sx={{ pt: 0 }}>
          <TextField name='marketingContent.triggeredMessageContent.progressSms' />
        </CardContent>
      </Collapse>
    </Paper>
  );
};
